import { useSelector } from "react-redux";
import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum";
import type { AppCoreState } from "../Redux/AppCoreReducer";
import type { RouteDef } from "./RouteDef";

export type RoutePathMap<T extends Record<string, RouteDef>> = {
  [K in keyof T]: string;
};

export function useRoutePaths<T extends Record<string, RouteDef>>(routes: T): RoutePathMap<T> {
  const lang = useSelector(
    (state: { core: AppCoreState }) => state.core.language ?? LanguageEnum.CS,
  );
  const result = {} as RoutePathMap<T>;
  for (const key in routes) {
    const def = routes[key];
    result[key] = def.paths[lang] ?? def.paths[LanguageEnum.CS] ?? "/";
  }
  return result;
}
